import styled from 'styled-components';
import {
  Menu as MenuComponent,
  MenuList as MenuListComponent,
  MenuListItem as MenuListItemComponent,
} from '@pearsontechnology/aero-components';
import iesV2Icon from 'images/favicon-light.png';

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  display: grid;
  overflow: hidden;
  height: ${(props) => props.height}px;
  transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const MenuList = styled(MenuListComponent)`
  position: relative;
  grid-column: 1;
  grid-row: 1;
  transform: translate3d(${(props) => props.status === 'entered' ? 0 : props.direction * 100}%, 0, 0);
  opacity: ${(props) => props.status === 'entered' ? 1 : 0};
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  align-items: flex-start;
`;

export const MenuListItem = styled(MenuListItemComponent)`
  max-height: 30px;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
`;

export const MenuItemIconRightWrapper = styled.span`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoutContainer = styled.div`
  display: flex;
`;

export const IesV2Image = styled.div`
  background-image: url(${iesV2Icon});
  background-color: ${(props) => props.theme['color.background']};
  background-position: center;
  background-size: 16px;
  width: 24px;
  margin-right: 8px;
`;
